import React, { useEffect, useState } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation } from "react-router-dom";
import { MdFileDownload } from "react-icons/md";

function AdminTickets(props) {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [detailTicket, setDetailTicket] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newCategoryPopup, setNewCategoryPopup] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [companies, setCompanies] = useState([]);
  const location = useLocation();
  const initialCompanyId = location.state?.companyId || "";
  const [selectedCompanyId, setSelectedCompanyId] = useState(initialCompanyId);
  const [showTicket, setShowTicket] = useState(false);
const [filterDate, setFilterDate] = useState("");
const [filterToDate, setFilterToDate] = useState("");
const [filterStatus, setFilterStatus] = useState("");
const[product,setProduct] = useState([]);


  useEffect(() => {
    const getTicketsData = async () => {
      try {
        if (props.clientDetails) {
          const response = await axios.get(
            `https://api.dectwinservices.com/api/tickets/${props.clientDetails.id}`
          );
          setTickets(response.data);
      
          localStorage.setItem("tickets", JSON.stringify(response.data));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/tickets"
          );
          setTickets(response.data);
   
          localStorage.setItem("tickets", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };



    const getCompanies = async () => {
      try {
        const storedCompany = localStorage.getItem("companies");

        if (storedCompany) {
          setCompanies(JSON.parse(storedCompany));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/companies"
          );
          setCompanies(response.data);
          localStorage.setItem("companies", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };

    getCompanies();
    getTicketsData();
  }, [props]);



useEffect(() => {
  const prodId = props.clientDetails?.item_id;

  if (!prodId) return;


  getProduct(prodId);

}, [props.clientDetails?.prod_id]);


 const getProduct = async (prodId) => {

  if (!prodId) return;

  try {
    const response = await axios.get(
      `https://api.dectwinservices.com/api/products-by-id/${prodId}`
    );


    setProduct(response.data)
  } catch (e) {
    console.log("API error:", e.response?.data || e.message);
  }
};

  const parseTicketDate = (dateString) => {
  if (!dateString) return null;

  // Convert "2026-08-06 14:08:00" -> "2026-08-06T14:08:00"
  const normalized = dateString.replace(" ", "T");

  const date = new Date(normalized);

  return isNaN(date.getTime()) ? null : date;
};

const filteredTickets = React.useMemo(() => {
  return tickets.filter((ticket) => {
    const matchCompany =
      !selectedCompanyId ||
      String(ticket.assign_comp) === String(selectedCompanyId);

    // const matchDate =
    //   !filterDate ||
    //   new Date(ticket.create_date).toISOString().slice(0, 10) === filterDate;
     const ticketDate = new Date(ticket.create_date);

  const fromDate = filterDate ? new Date(filterDate) : null;
  const toDate = filterToDate ? new Date(filterToDate) : null;

  if (fromDate) {
    fromDate.setHours(0, 0, 0, 0);
  }

  if (toDate) {
    toDate.setHours(23, 59, 59, 999);
  }

  const matchDate =
    (!fromDate || ticketDate >= fromDate) &&
    (!toDate || ticketDate <= toDate);

    const matchStatus =
      !filterStatus ||
      ticket.status.toLowerCase() === filterStatus.toLowerCase();

    return matchCompany && matchDate && matchStatus;
  });
}, [tickets, selectedCompanyId, filterDate, filterToDate, filterStatus]);


  const handleEditClick = (ticket) => {
    setSelectedTicket(ticket);
    setShowEditModal(true);
  };

  const handleShowDetail = (tkt) => {
setDetailTicket(tkt);
setShowTicket(true);
}

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setSelectedTicket((prev) => ({ ...prev, [name]: value }));
  };


  const handleUpdate = async () => {
    if(selectedTicket.status == ''){
      props.handleToast({
        toastMsg: "Select Ticket status to Update",
        toastColor: "#FF0000",
      }); 
      return;
    }
    try {
      const response = await axios.put(
        `https://api.dectwinservices.com/api/update-ticket/${selectedTicket.ticket_id}`,
        selectedTicket
      );

      if (response.status === 200) {
        // Update local state
        setTickets((prev) =>
          prev.map((t) =>
            t.ticket_id === selectedTicket.ticket_id ? selectedTicket : t
          )
        );
        setShowEditModal(false);
        props.handleToast({
          toastMsg: "Ticket updated successfully!",
          toastColor: "#4CAF50",
        });
      }
    } catch (err) {
      console.error(err);
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

  const exportToExcel = () => {
    if (!tickets || tickets.length === 0) {
      console.error("No data to export.");
      return;
    }

    // Define the columns for the Excel file
    const formattedData = filteredTickets.map((item) => ({
      "Ticket Id": `${props.clientDetails == null ? `${item.assigned_company_id}-` : `${props.clientDetails.company_id}-`}${item.ticket_inv}`,
      "Title/ Issue": item.title,
      "Description": item.description,
      "Category": item.category,
      "Sub Category": item.sub_category,
      "Priority": (item.urgency == "1"
        ? "Priority 1"
        : item.urgency == "2"
          ? "Priority 2"
          : "Priority 3"),
      "Create Date": item.create_date,
      "Solve Date": item.solve_date || 'Pending',
      'Status': item.status,
      // "Assigned Item": item.item_id,
      // "Assigned Date": item.item_assign_date,
      // Designation: item.designation,
      // Department: item.department,
    }));

    // Create a new worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");

    // Convert workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Tickets.xlsx`);
  };


  function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}


  return (
    <section className="px-32">
      <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-show" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big mb-2">&nbsp;View Ticket Status</p>
          </div>

<div className="d-md-flex d-sm-flex">
  
  <div className="my-2 px-1">
  <input
    type="date"
    value={filterDate}
    title="From Date"
    onChange={(e) => setFilterDate(e.target.value)}
    className="form-control"
    style={{
      // padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    }}
  />
</div>

<div className="my-2 px-1">
  <input
    type="date"
    value={filterToDate}
    onChange={(e) => setFilterToDate(e.target.value)}
    className="form-control"
    title="To Date"
    min={filterDate || undefined}
    style={{
      padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    }}
  />
  </div>

<div className="my-2 px-1">  <select
    value={filterStatus}
    onChange={(e) => setFilterStatus(e.target.value)}
    className="form-control"
    style={{
      // padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    }}
  >
    <option value="">All Status</option>
    <option value="Open">Open</option>
    <option value="Closed">Closed</option>
  </select>
</div>


  {!props.clientDetails && 
  <div className="my-2 px-1">
            <select
      style={{
        // padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
      }}
              className="form-control"
              value={selectedCompanyId}
              onChange={(e) => setSelectedCompanyId(e.target.value)}
            >
              <option value="">All Companies</option>
              {companies.map((comp) => (
                <option key={comp.id} value={comp.id}>
                  {comp.company_name}
                </option>
              ))}
            </select>
</div>}

         <div className="my-2 px-1"> <button
          className="add-btn"
          style={{ background: "#00AA00" }}
          onClick={exportToExcel}
        >
       <MdFileDownload size={20} />
         Excel
        </button>
</div>
</div>

      </div>

      
      <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
          <thead className="bg-grey text-center">
            {/* <tr className="t-head text-center align-middle rounded-top-3"> */}
              <th className="p-2">Ticket Id</th>
              <th className="p-2">Title/Issue</th>
              {/* <th style={{ flex: "1" }}>Description</th> */}
              <th className="p-2">Category</th>
              <th className="p-2">Priority</th>
              <th className="p-2">Create Date</th>
              <th className="p-2">Resolve Date</th>
              <th className="p-2">Engineer</th>

              <th className="p-2">Status</th>
              {/* {clientDetails?.is_admin == 'Employee' ?               <th className="p-2">
                <i className="bx bxs-cog"></i>
              </th> : ''} */}
    <th className="p-2">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>

            {/* </tr> */}
          </thead>

    
              {filteredTickets.map((tkt, index) => (
                <tr key={index} style={{cursor: 'pointer'}} className="text-center" onClick={() => handleShowDetail(tkt)}>
                  <th className="p-2">{props.clientDetails == null ? `${tkt.assigned_company_id}-` : `${props.clientDetails.company_id}-`}{tkt.ticket_inv}</th>
                  <th className="p-2"
  >  <div className="line-clamp-2">{tkt.title}</div>
</th>
                  {/* <th style={{
    flex: "1",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}>{tkt.description}</th> */}
                  <th className="p-2">{tkt.category}</th>
                  <th
                  className="p-2"
                 
                  >
                    <span    style={{
                      // flex: "0.4",
                      backgroundColor: tkt.status != 'Closed' ?
                        tkt.urgency == "1"
                          ? "#FF4C4C"
                          : tkt.urgency == "2"
                            ? "#FFD700"
                            : "#4CAF50"
                            : 'white',
                      color: tkt.status != 'Closed' ? "#fff" : 'black',
                      borderRadius: "4px",
                  
                    }}>
                    {tkt.urgency == "1"
                      ? "Priority 1"
                      : tkt.urgency == "2"
                        ? "Priority 2"
                        : "Priority 3"}
                        </span>
                  </th>
                  <th className="p-2">{removeSeconds(tkt.create_date)}</th>
                  {/* <th>
  {new Date(tkt.create_date).toLocaleString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })}
</th> */}
                  <th className="p-2">{tkt.solve_date ? removeSeconds(tkt.solve_date) : "Pending"}</th>
               <th className="p-2">{tkt.assigned_tech_name ?? '-'}</th>   
                <th className="p-2">{tkt.status}</th>

                  {/* {clientDetails?.is_admin === 'Employee' ? (
  tkt.status === 'Open' ? (
    <th onClick={() => handleEditClick(tkt)} className="pointer">
      <i className="bx bx-dots-vertical-rounded"></i>
    </th>
  ) : (
    <th>✔</th>
  )
) : (
  ''
)} */}

{/* {props.clientDetails != null &&
                  (
                    tkt.status === 'Open' ? (
                      <th onClick={(e) => {    e.stopPropagation();
handleEditClick(tkt)}} className="pointer">
                        <i className="bx bx-dots-vertical-rounded"></i>
                      </th>
                    ) : (
                      <th>✔</th>
                    )
                  )
} */}

{/* {props.clientDetails == null && */}
               {tkt.status != 'Closed' ?
    <th
  onClick={(e) => {
    e.stopPropagation();
    handleEditClick(tkt);
  }}
  className="pointer"
>
  <i className="bx bx-dots-vertical-rounded"></i>
</th> : <th><span className="px-3">&nbsp; &nbsp;</span></th>
}
{/* } */}

                </tr>
              ))}
         </table>

      </div>
      {showEditModal && (
        <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1em' }}>
            <h3>Edit Ticket</h3>

            <div className="form-data">
              <label htmlFor="title">Title/Issue/ Issue</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  name="title"
                  value={selectedTicket.title}
                  onChange={handleModalChange}
                />
              </div>
            </div>


            <div className="form-data" style={{ margin: '0.6em 0em' }}>
              <label htmlFor="description">Ticket Description</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <textarea
                  name="description"
                  value={selectedTicket.description}
                  onChange={handleModalChange}
                  placeholder="Enter Ticket's Description"
                  required
                />
              </div>
            </div>

            <div className="form-data" style={{ margin: '0.6em 0em' }}>
              <label htmlFor="category">Category</label>
              <div className="input-icon">
                <i className="bx bxs-category-alt"></i>
                <select
                  name="category"
                  id="category"
                  value={selectedTicket.category}
                  onChange={(e) => {
                    if (e.target.value === "__add_new__") {
                      setNewCategoryPopup(true);
                    } else {
                      handleModalChange(e);
                    }
                  }}
                >
                  <option value="">Select Category</option>
                  <option value={selectedTicket.category}>
                    {selectedTicket.category}
                  </option>
                  <option value="__add_new__">+ Add New Category</option>
                </select>
              </div>
            </div>

{/* {props.clientDetails == null && selectedTicket.status == 'Closed' && */}
{/* {selectedTicket.status == 'Closed' && */}
<div className="form-data" style={{ margin: '1em 0em' }}>
  <label htmlFor="status">Ticket Status</label>
  <div className="input-icon">
    <i className="bx bxs-check-circle"></i>
    <select
      name="status"
      id="status"
      value={selectedTicket.status}
      onChange={handleModalChange}
      required
    >
      <option value="">Select Status</option>
      <option value="Open">Open</option>
      {/* <option value="In Progress">In Progress</option>
      <option value="On Hold">On Hold</option> */}
      <option value="Closed">Closed</option>
    </select>
  </div>
</div>
{/* } */}

            {props.clientDetails != null &&
              <div className="form-data" style={{ margin: '1.2em 0em' }}>
                <label htmlFor="urgency">Priority/ Urgency</label>
                <div className="input-icon">
                  <i className="bx bxs-category-alt"></i>
                  <select
                    name="urgency"
                    id="urgency"
                    value={selectedTicket.urgency}
                    onChange={handleModalChange}
                    required
                    disabled
                  >
                    {props.clientDetails?.priority == '3' && (
                      <>
                        <option value="">Select Priority</option>
                        <option value="2">Priority 2</option>
                        <option value="3">Priority 3</option>
                      </>)}

                    {props.clientDetails?.priority == '2' || props.clientDetails?.priority == '1' && (
                      <option value="1">Priority 1</option>
                    )}
                    {/* <option name="1">Priority 1</option>
                  <option name="2">Priority 2</option>
                  <option name="3">Priority 3</option> */}
                  </select>
                </div>
              </div>
            }

            <div className="btn-group d-flex" style={{ justifyContent: "end" }}>
              <button className="add-btn" type="button" onClick={() => setShowEditModal(false)}>
                Cancel
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button className='add-btn' onClick={handleUpdate}>Update</button>
            </div>
            {/* <div className="modal-actions">
              <button onClick={handleUpdate}>Save</button>
              <button onClick={() => setShowEditModal(false)}>Cancel</button>
            </div> */}

          </div>
        </div>
      )}

      {newCategoryPopup && (
        <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
            <h3>Add New Category</h3>


            <div className="form-data" style={{ margin: '0.8em 0em' }}>
              <label htmlFor="title">Title/Issue/ Issue</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                  placeholder="Enter new category name"
                />
              </div>
            </div>


            <div className="btn-group d-flex" style={{ justifyContent: "end" }}>
              <button
                onClick={() => {
                  setNewCategoryPopup(false);
                  setNewCategory("");
                }}
                className="add-btn"
              >
                Cancel
              </button>              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                onClick={() => {
                  if (newCategory.trim()) {
                    setSelectedTicket((prev) => ({
                      ...prev,
                      category: newCategory,
                    }));
                    setNewCategory("");
                    setNewCategoryPopup(false);
                  }
                }}

                className="add-btn"
              >
                Save
              </button>            </div>

          </div>
        </div>
      )}

      {showTicket && (
                <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
            <h3>Ticket Details: ID {detailTicket.ticket_inv}</h3>


 <div  className="row">
                 
    <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Ticket Issue:</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
             
                  value={detailTicket.title}
              
                  placeholder="Enter Ticket's Title"
                  required
                />
              </div>
            </div>


    <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Category</label>
              <div className="input-icon">
                <i className="bx bx-category"></i>
                <input
                  type="text"
                
                  value={detailTicket.category}
              
                    placeholder="Ticket category"
                  required
                />
              </div>
            </div>

                <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Sub Category</label>
              <div className="input-icon">
                <i className="bx-list-ul"></i>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={detailTicket.sub_category}
              
                    placeholder="Ticket sub-category"
                  required
                />
              </div>
            </div>


             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Device Type</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_sub_cat || product.sub_category}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

             
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Asset ID</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_asset_no || product.barcode}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

             
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Product Serial No</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_sr_no || product.serial_no}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>
             <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Priority</label>
              <div className="input-icon">
              <i className="bx bx-error-circle"></i>
                <input
                  type="text"
                  value={detailTicket.urgency}
              
                    placeholder="Priority level"
                  required
                />
              </div>
            </div>

      {props.clientDetails == null &&
      <>
       <div className="form-data col-md-4 col-12 ticket-column">
            <label>Company</label>
<div className="input-icon">
  <i className="bx bx-buildings"></i>
  <input
    type="text"
    value={detailTicket.assigned_company_name}
    placeholder="Company name"
    readOnly
  />
</div>
            </div>

             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Raised By</label>
<div className="input-icon">
  <i className="bx bx-user"></i>
  <input
    type="text"
    value={detailTicket.assigned_by_name}
    placeholder="Ticket creator"
    readOnly
  />
</div>
            </div>
             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Role</label>
<div className="input-icon">
  <i className="bx bx-id-card"></i>
  <input
    type="text"
    value={detailTicket.assigned_by_role}
    placeholder="User role"
    readOnly
  />
</div>
            </div>
      </>
}

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Created On</label>
<div className="input-icon">
  <i className="bx bx-calendar"></i>
  <input
    type="text"
    value={removeSeconds(detailTicket.create_date)}
    placeholder="Ticket creation date"
    readOnly
  />
</div>
            </div>

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Prefered Contact Time</label>
<div className="input-icon">
  <i className="bx bx-clock"></i>
  <input
    type="text"
    value={detailTicket.contact_time}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Prevoius Ticket Reference</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.ticket_reference}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

            
     
             <div className="form-data col-md-4 col-12 ">
  <label>Raised Attachment</label>

  <div className="input-icon">
    <i className="bx bx-link"></i>

    {detailTicket.attachments ? (
      <a
        href={`https://api.dectwinservices.com/uploads/${detailTicket.attachments}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007bff", textDecoration: "underline", height:'45px',paddingTop:'8px' }}
      >
        Open Attachment
      </a>
    ) : (
      <span   style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
    )}
  </div>
</div>

<div></div>


             <div className="form-data col-12 ticket-column">
            <label>Description</label>
<div className="input-icon">
  <i className="bx bx-detail"></i>
  <textarea
    type="text"
    value={detailTicket.description}
    placeholder="Issue description"
    readOnly
  />
</div>
            </div>
        

             <div className="form-data col-md-4 col-12 ticket-column">
            <label>Resolved On</label>
<div className="input-icon">
  <i className="bx bx-check-circle"></i>
  <input
    type="text"
    value={detailTicket.solve_date ? removeSeconds(detailTicket.solve_date) : "Pending"}
    placeholder="Resolution date"
    readOnly
  />
</div>
            </div>




             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Status</label>
<div className="input-icon">
  <i className="bx bx-loader-circle"></i>
  <input
    type="text"
    value={detailTicket.status}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>


              {detailTicket.assigned_tech_name != null && (
  <>
             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Engineer</label>
<div className="input-icon">
  <i className="bx bx-user-check"></i>
  <input
    type="text"
    value={detailTicket.assigned_tech_name}
    placeholder="Assigned technician"
    readOnly
  />
</div>
            </div>

               <div className="form-data col-md-4 col-12 ticket-column">
             <label>Engineer Remark</label>
<div className="input-icon">
  <i className="bx bx-user-check"></i>
  <input
    type="text"
    value={detailTicket.resolve_notes}
    placeholder="Assigned technician"
    readOnly
  />
</div>
            </div>

                  <div className="form-data col-md-4 col-12 ticket-column">
  <label>Eng Attachment</label>

  <div className="input-icon">
    <i className="bx bx-link"></i>

    {detailTicket.solve_attachments ? (
      <a
        href={`https://api.dectwinservices.com/uploads/${detailTicket.solve_attachments}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px' }}
      >
        Open Attachment
      </a>
    ) : (
      <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
    )}
  </div>
</div>
            

  </>
  
 )}
            
  
            </div>


            {/* <p>Title/Issue/ Issue: {detailTicket.title}<br />
            Category: {detailTicket.category}<br />
            Sub Category: {detailTicket.sub_category || 'NA'}<br />
            Priority: Priority{detailTicket.urgency}<br /><br />

{props.clientDetails == null &&
<>
            Company: {detailTicket.assigned_company_name}<br />
            Raised By: {detailTicket.assigned_by_name}<br />
            Role: {detailTicket.assigned_by_role}<br />
</> }


            Created On: {detailTicket.create_date}<br /><br />
            Description: {detailTicket.description}<br />
            Note: {detailTicket.resolve_notes || 'NA'}<br /><br />
                        Resolved On: {detailTicket.solve_date || 'NA'}<br />
                        {detailTicket.assigned_tech_name != null && (
                          <>
                        Resolved By: {detailTicket.assigned_tech_name || 'NA'} ({detailTicket.assigned_tech_des})<br />
                          </>
                        )}
                        Status: {detailTicket.status}
</p> */}
<br />

            <button className="add-btn" onClick={() => setShowTicket(false)}>Close</button>

</div>
</div>
      )}

    </section>
  );
}

export default AdminTickets;
